import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

/**
 * Port of cdc-web `src/utils/dayjs.ts`：prediction 卡片区的 dayjs 单例，装载
 * duration 插件（useCountdownTimer 的 `dayjs.duration` 依赖）。本仓全局的
 * `@/utils/dateFormat` 只装 utc，不动它以免扩大影响面。
 */
dayjs.extend(duration)

export default dayjs
